import { useEffect } from 'react';
import { updateFavicon, updatePageTitle } from '../utils/faviconUtils';
const defaultFavicon = '/T.png';

export const useTenantBranding = (isSubdomain) => {
  useEffect(() => {
    // Only apply branding if it's a subdomain
    if (!isSubdomain) {
      // For main domain, set default Truyon branding
      updateFavicon(defaultFavicon);
      updatePageTitle('Truyon');
      return;
    }

    // For subdomains, get stored favicon and title
    const storedFavicon = localStorage.getItem('tenantFavicon');
    const storedTitle = localStorage.getItem('tenantTitle');
    
    console.log('🔍 Applying stored branding - favicon:', storedFavicon, 'title:', storedTitle);
    
    // Apply stored branding if available, otherwise use defaults
    if (storedFavicon) {
      updateFavicon(storedFavicon);
    } else {
      updateFavicon(defaultFavicon);
    }
    
    if (storedTitle) {
      updatePageTitle(storedTitle);
    } else {
      updatePageTitle('Truyon');
    }
  }, [isSubdomain]); // Run when isSubdomain changes
};